import styled from 'styled-components';

export const MultiSelectWrapper = styled.div`
  width: 100%;
`;
